import { Global } from "@emotion/react";

const SupChatStyles = () => (
  <Global
    styles={`
      #sw-supchatwidget-btn[style],
      #supchat-trigger {
        bottom: 80px !important;
        right: 16px !important;
        @media (max-width: 991px) {
          bottom: 112px !important;
          right: 16px !important;
        }
      }`}
  />
);

export default SupChatStyles;
